import { createContext } from "react";

/** What the user picked. `system` follows OS preference at runtime. */
export type ThemePreference = "light" | "dark" | "system";

/** What's actually applied to the DOM (resolved). */
export type Theme = "light" | "dark";

export interface ThemeContextProps {
  /** Resolved theme currently applied (always light or dark). */
  theme: Theme;
  /** User-selected preference, including `system`. */
  preference: ThemePreference;
  /** Set the preference explicitly. */
  setPreference: (preference: ThemePreference) => void;
  /** Toggle between light/dark (collapses system into the opposite of the current resolved theme). */
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);
